import type { ActionProperties } from "@octopusdeploy/octopus-server-client";

export type CommunityTemplatePropertiesResult = {
    propertiesToOverwrite: ActionProperties;
    propertyKeysToRemove: string[];
};

export function getUpdatedCommunityTemplateProperties(newProperties: ActionProperties, newParameterNames: string[], currentProperties: ActionProperties): CommunityTemplatePropertiesResult {
    const propertiesToOverwrite = { ...newProperties };

    const newPropertyKeys = [...Object.keys(propertiesToOverwrite), ...newParameterNames];
    const propertyKeysToRemove = Object.keys(currentProperties).filter((key) => !newPropertyKeys.includes(key));

    delete propertiesToOverwrite["Octopus.Action.RunOnServer"];

    return {
        propertiesToOverwrite,
        propertyKeysToRemove,
    };
}
